module.exports = __webpack_public_path__ + "img/女-慢性阻塞性肺病h.2098606f.png";